const SCRIPT_TAG = 'script';

if (typeof window.isHubSpotLoaded === 'undefined') {
  window.isHubSpotLoaded = false;
}

function log(message) {
  if (RAILS_ENV === 'production') {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(message);
}

function identify() {
  if (window.currentUser) {
    log('Identifying user with HubSpot');
    var _hsq = (window._hsq = window._hsq || []);
    _hsq.push([
      'identify',
      {
        email: window.currentUser.email,
        id: window.currentUser.id,
        qc_subscription_api: window.currentUser.subscriptionStatus
      }
    ]);
  }
}

async function startHubSpotScript(
  id = 'hs-script-loader',
  src = '//js.hs-scripts.com/44326808.js'
) {
  return new Promise((resolve, reject) => {
    const lastScriptElement = document.getElementsByTagName(SCRIPT_TAG)[0];
    const scriptElement = document.createElement(SCRIPT_TAG);

    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    scriptElement.id = id;
    scriptElement.onload = () => resolve();
    scriptElement.onerror = error => reject(error);
    scriptElement.src = src;
    lastScriptElement.parentNode.insertBefore(scriptElement, lastScriptElement);
  });
}

function bindTurbolinks() {
  document.addEventListener('turbolinks:load', () => {
    log('Tracking Hubspot page view with turbolinks:load event');
    identify();
    var _hsq = (window._hsq = window._hsq || []);
    _hsq.push(['setPath', location.pathname + location.search]);
    _hsq.push(['trackPageView']);

    startHubSpotScript().then(() => {
      log('HubSpot script reloaded');
    });
  });

  document.addEventListener('turbolinks:before-visit', () => {
    const webInteractiveEmbed =
      'script[src="https://js.hubspot.com/web-interactives-embed.js"]';
    const el = document.querySelector(webInteractiveEmbed);

    if (el) {
      window.hubspot_web_interactives_running = false;
      el.remove();
      log('Removing web-interactives-embed.js script tag');
    }

    const hsScript = 'script[src="//js.hs-scripts.com/44326808.js"]';
    const el2 = document.querySelector(hsScript);

    if (el2) {
      window.hubspot_web_interactives_running = false;
      el2.remove();
      log('Removing hs-scripts.com script tag');
    }
  });
}

function onLoaded() {
  window.isHubSpotLoaded = true;
  log('HubSpot loaded');
  identify();
  bindTurbolinks();
}

if (!window.isHubSpotLoaded) {
  Promise.all([startHubSpotScript()].filter(Boolean))
    .then(() => onLoaded())
    // .catch(err => Rollbar.error('Erro ao inicializar HubSpot', err));
    .catch(() => log('Erro ao inicializar HubSpot'));
}
